<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 30641 30641"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="30641" height="30641" rx="2988" ry="2988"/>
  <g id="_862401040">
   <path class="fil1" d="M4299 26834l5595 -2c-109,-5151 -4,-10923 -3,-16187 0,-892 45,-1685 -464,-2248 -512,-568 -1419,-418 -2320,-418 -832,0 -1818,-145 -2307,360 -519,537 -512,1302 -512,2234l0 10808c0,1779 -67,3691 11,5453z"/>
   <path class="fil1" d="M17615 26834l8658 -24 -32 -9677c-771,-508 -3215,-737 -4319,-722 -1780,24 -2768,348 -4309,672l2 9751z"/>
   <path class="fil1" d="M3826 6471l6522 -7 -106 -846c2259,-6 2915,-19 2918,2450l9 10740c95,780 587,1254 1288,1450 785,218 1751,42 2584,127l5 7005 9769 6 -17 -10668c-940,-595 -3556,-901 -4876,-880 -1125,18 -4113,371 -4858,880l-19 3062c-619,72 -2005,70 -2520,-98 -856,-279 -796,-937 -796,-1890 -1,-998 71,-10045 -46,-10803 -347,-2262 -2129,-1939 -3497,-1952l-170 -1257c-1265,-738 -3682,-639 -5262,-215 -499,134 -571,43 -633,567 -91,771 -217,1544 -295,2329z"/>
   <path class="fil1" d="M3738 27397l6705 -2c127,-3824 7,-7844 7,-11668 0,-1933 1,-3866 0,-5799 -3,-2727 -1817,-2512 -3343,-2512 -1391,0 -3379,-264 -3388,2441l1 14601c0,913 -60,2055 18,2939z"/>
   <path class="fil1" d="M4715 4177l-241 1694 5189 7c39,-201 -74,-1438 -172,-1625 -157,-299 -1048,-365 -1434,-411 -1066,-127 -2387,33 -3342,335z"/>
   <path class="fil1" d="M6177 7266l2004 0c504,0 749,32 599,-510 -909,-112 -1727,-55 -2675,-52 -333,0 -766,-63 -758,291 8,353 488,271 830,271z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'WaterSoftener',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#00A0E3}
</style>
